import React, { useMemo, Suspense, lazy } from "react";
import Card from "../../components/Card/card";
import "./widgets.css";
import config from "./dashboardCardConfigs.json";
import { Spinner } from '@abb/abb-common-ux-react';


const LAZY_COMPONENTS = {
  OperationStatus: lazy(() => import("../../components/DR-Dashboard/Operation-Status/operation-status")),
  CriticalAlerts: lazy(() => import("../../components/DR-Dashboard/Gauge-Critical-Alerts/critical-alerts")),
  AlarmSummary: lazy(() => import("../../components/DR-Dashboard/Donut-Alarm-Summary/alarm-summary")),
  AlarmNotificationsData: lazy(() => import("../../components/DR-Dashboard/Alarm-Notifications/alarm-noti-datagrid")),
  FeederMeasurement: lazy(() => import("../../components/DR-Dashboard/Feeder-Measurement/feeder-measurement")),
  CurrentTrend: lazy(() => import("../../components/DR-Dashboard/Line-Current-Trend/current-trend")),
  VoltageTrend: lazy(() => import("../../components/DR-Dashboard/Line-Voltage-Trend/voltage-trend")),
  PowerMeasurement: lazy(() => import("../../components/DR-Dashboard/Gauge-Power-Measurement/power-measurement")),
  DisturbanceEvents: lazy(() => import("../../components/DR-Dashboard/Bar-Disturbance-Events/disturbance-events")),
  DisturbanceMeasurementData: lazy(() => import("../../components/DR-Dashboard/Disturbance-Records/disurbance-measurements-datagrid")),
  EventLog: lazy(() => import("../../components/DR-Dashboard/Donut-Event-Log/event-log")),
  FaultDuration: lazy(() => import("../../components/DR-Dashboard/Donut-Fault-Duration/fault-duration")),
};


const WidgetFallback = () => (
  <div className="widget-spinner">
    <Spinner
      style={{ margin: "auto" }}
      color="dark-grey"
      size="small"
  ></Spinner>
  </div>
);

function Widgets() {
  const componentMap = useMemo(() => LAZY_COMPONENTS, []);

  return (
    <div className="widget-container">
      {config
        .filter(({ isVisible }) => isVisible)
        .map(({ widgetName, widgetUpdateTime, component: componentKey, applystyle }) => {
          const Component = componentMap[componentKey];

          return (
            <Card
              key={widgetName}
              widgetName={widgetName}
              widgetUpdateTime={widgetUpdateTime}
              component={
                <Suspense fallback={<WidgetFallback />}>
                  <Component />
                </Suspense>
              }
              applystyle={applystyle}
            />
          );
        })}
    </div>
  );
}

export default Widgets;